import { createContext, useContext, type ReactNode } from "react";
import "./StepLayout.css";

const InlineStepContext = createContext(false);
export const useInlineStep = () => useContext(InlineStepContext);

/** Page presentation for reusable onboarding steps; dialogs remain the default. */
const StepLayout = ({
  inline = false,
  children,
}: {
  inline?: boolean;
  children: ReactNode;
}) => {
  if (!inline) return <>{children}</>;
  return (
    <InlineStepContext.Provider value={true}>
      <div className="ds-step-layout">
        <div className="ds-step-layout__content">{children}</div>
      </div>
    </InlineStepContext.Provider>
  );
};
export default StepLayout;
